import { services } from '../../../../api/feathers';

export const GET_DEVICES_LOGS = 'GET_DEVICES_LOGS';

export function getDevicesLogsList(id, query = {}) {
  return (dispatch) =>
    services.elasticServices.get(id, query).then((response) => {
      dispatch({
        type: GET_DEVICES_LOGS,
        payload: response.hits.hits,
      });
    });
}

export function getAndSetFirstLogDevice(id, query = {}) {
  return () =>
    services.elasticServices
      .get(id, query)
      .then((response) => {
        const { hits: { hits: [firstHit = {}] = [] } = {} } = response;
        // eslint-disable-next-line no-underscore-dangle
        const { _source: { packageTime } = {} } = firstHit;
        return packageTime || null;
      })
      .catch((error) => {
        console.error('Error in getAndSetFirstLogDevice:', error);
        return null;
      });
}
